import {createContext} from 'react';

import type {Nullable} from '../../utils/utility-types';
import type {ContainerBinder} from '../ContainerBinder';

import {ROOT_CONTAINER_KEY} from '../utils';

type K = string | typeof ROOT_CONTAINER_KEY;

export const InjectionContext = createContext<
  Map<K, Nullable<ContainerBinder.Container>>
>(
  new Map<K, Nullable<ContainerBinder.Container>>([[ROOT_CONTAINER_KEY, null]]),
);
